<app-expansion-list
    (onAdd)="emit_btnAddClick()"
    (onClick)="emit_onClick($event)"
    (onRestore)="emit_onRestore($event)"
    [(tabMode)]="tabMode$$"
    [btnAddData]="btnAddData$$()"
    [btnDeleteData]="btnDeleteData$$()"
    [expandableOf]="expandableOf"
    [panelTemplate]="viewSpec$$().panel === _panel.none ? null : viewSpec$$().panel === _panel.details ? template_details : template_periods"
    [deletedListByData]="true"
    [inactiveMode]="_inactiveMode.dimmed"
    [restoreHide]="true"
    [rowToggles]="viewSpec$$().click === _click.none"
    [toggleTextOf]="toggleTextOf"
    [claimPageList]="claimPageList$$()"
    [itemLines]="itemLines"
    [itemSize]="ItemSize"
    [noClick]="noClick$$()"
    [template]="template"
/>

<ng-template #template let-listItem>
    @if (viewSpec$$().photo !== _photoNone) {
        <app-image-box-tab-list matListItemAvatar
            [border]="true"
            [noClick]="true"
            [guid]="photoGuid(listItem)"
            [version]="photoVersion(listItem)" />
    }
    <div class="role-row">
        @if (listItem?.[function_isProjectManager]) {
            <app-icon class="role-icon" name="project-manager" [matTooltip]="listItem?.[function_label]" [matTooltipPosition]="'left'" />
        } @else if (listItem?.[function_isAdmin]) {
            <app-icon class="role-icon" name="administrator" [matTooltip]="listItem?.[function_label]" [matTooltipPosition]="'left'" />
        } @else {
            <app-icon class="role-icon role-icon-hidden" name="user" />
        }
        <!-- Regels volgens de weergave-versie (TabDataTemplate.listView, zie function-member-list-view.ts): de eerste
             regel is de titel, met inactief-suffix. -->
        <div class="role-row-text">
            @for (part of viewSpec$$().lines; track part; let first = $first) {
                @if (first) {
                    <h3 matListItemTitle>
                        <ng-container *ngTemplateOutlet="template_part; context: {$implicit: listItem, part: part, title: true}" />
                    </h3>
                } @else if (partVisible(listItem, part)) {
                    <p matListItemLine [class.access-dates]="part === _rowPart.dates">
                        <ng-container *ngTemplateOutlet="template_part; context: {$implicit: listItem, part: part}" />
                    </p>
                }
            }
        </div>
    </div>
</ng-template>

<!-- Eén bouwsteen van een rij (functionMemberRowPart); als titel met inactief-suffix achter de naam. -->
<ng-template #template_part let-listItem let-part="part" let-title="title">
    @switch (part) {
        @case (_rowPart.function) {{{listItem?.[function_label] | inactiveSuffix:(title && !listItem?.[active])}}}
        @case (_rowPart.person) {{{listItem?.[displayName]}}@if (listItem?.[organisationLabel]) {<span class="name-suffix">{{ organisationSeparator }}{{ listItem?.[organisationLabel] }}</span>}@if (title && !listItem?.[active]) {{{_inactiveSuffixText}}}}
        @case (_rowPart.context) {@if (listItem?.[project_name]) {project: {{listItem?.[domain_name]}} - {{listItem?.[project_name]}}} @else {domain: {{listItem?.[domain_name]}}}}
        @case (_rowPart.project) {project: {{listItem?.[project_name]}}}
        @case (_rowPart.dates) {@if (listItem?.[startDate]) {start: {{listItem?.[startDate] | appDate}}@if (listItem?.[endDate]) { &nbsp;&nbsp;end: {{listItem?.[endDate] | appDate}} }}}
    }
</ng-template>

<!-- Paneel 'details' (weergaven domainUser en projectMember): alleen de historie, nieuwste periode eerst —
     die laat ook de huidige status zien (lopend, of tot wanneer en waarom beëindigd). Er is geen doorklik.
     De historie komt alleen mee als de server hem stuurt (datagroep SuperiorData). -->
<ng-template #template_details let-listItem>
    <ul class="period-list">
        @for (period of allPeriods(listItem); track $index) {
            <li class="period-row">
                {{ _periodText.from }} {{ period.startDate | appDate }}
                @if (period.endDate) { {{ _periodText.until }} {{ period.endDate | appDate }} } @else { · {{ _periodText.running }} }
                @if (period.endReason) { · {{ _periodReasonLabel[period.endReason] }} }
                · {{ period.fullDays }} {{ _periodText.fullDays }}
            </li>
        }
    </ul>
</ng-template>

<!-- Paneel 'periods' (ExpansionListComponent): de eerdere periodes van deze functie, één regel per periode. -->
<ng-template #template_periods let-listItem>
    <ul class="period-list">
        @for (period of earlierPeriods(listItem); track $index) {
            <li class="period-row">
                {{ _periodText.from }} {{ period.startDate | appDate }}
                @if (period.endDate) { {{ _periodText.until }} {{ period.endDate | appDate }} } @else { · {{ _periodText.running }} }
                @if (period.endReason) { · {{ _periodReasonLabel[period.endReason] }} }
                · {{ period.fullDays }} {{ _periodText.fullDays }}
            </li>
        }
    </ul>
</ng-template>
